const cleanMessage = {
  Id: '',
  Message: '',
  Username: '',
  WorkOrderId: 0,
  ReadDateTime: '',
  ReplyDateTime: '',
  Operator: '',
  MessageSource: '',
  loadedMessages: [],
};

export default {
  messages: {},
  chatHistory: {},
  loadedMessages: {},
  messageCounts: {},
  isTyping: false,
  directMessageCount: 0,
  cleanMessage: JSON.parse(JSON.stringify(cleanMessage)),
  files: [],
  channels: [],
  token: ''
};
